import {
  GET_DIMENSIONS_OUTCOMES_WATCHER,
  GET_DIMENSIONS_OUTCOMES_SUCCESS,
  GET_DIMENSIONS_OUTCOMES_FAILED,
} from "./constants"

export function getDimensionsOutcomesWatcher(payload) {
  return {
    type: GET_DIMENSIONS_OUTCOMES_WATCHER,
    payload,
  }
}

export function getDimensionsOutcomesSuccess(payload) {
  return {
    type: GET_DIMENSIONS_OUTCOMES_SUCCESS,
    payload,
  }
}

export function getDimensionsOutcomesFailed() {
  return { type: GET_DIMENSIONS_OUTCOMES_FAILED }
}
